import { ResponseStatus } from 'app/api';

export type isError = (status: ResponseStatus) => boolean;

export const isAlertError: isError = (status) => {
  return (
    status === ResponseStatus.BAD_REQUEST
    || status === ResponseStatus.NOT_FOUND
    || status === ResponseStatus.INTERNAL_SERVER
  );
};
